<template>
  <div
    class="bg-background-neutral-secondary divide-situational-lightgrey divide-y rounded-2xl px-4"
  >
    <TransferAmountFilter
      v-if="availableNumberOfTransfers.size > 0"
      class="py-4"
      :max-transfers="maxTransfers"
      :available-number-of-transfers="availableNumberOfTransfers"
      @onTransferAmountChange="changeMaxTransfers"
    />
    <RangeFilter
      v-if="limits[1] !== 0 && limits[0] !== limits[1]"
      :title="t('search.filters.transferDuration')"
      :state="props.state.flights[0].transfersDuration"
      :limits="limits"
      class="py-4"
      @onUpdate="changeTransferDuration"
    >
      <template #label="{ label }">
        <span>{{ offersFilterLib.formatDurationLabel(label) }}</span>
      </template>
    </RangeFilter>
    <TransferWithoutNightFilter
      class="py-4"
      :state="state"
      @onNightTransferFilterChange="emit('onNightTransferFilterChange', $event)"
    />
  </div>
</template>

<script setup lang="ts">
  import { isNil } from 'lodash-es';
  import { useI18n } from 'vue-i18n';
  import { computed } from 'vue';
  import {
    type FilterState,
    type FlightFilterState,
    getNumberOfTransfers,
  } from '@aviata/offers-filters-fns';
  import type { flightEntity } from 'freedom-shared';

  import { offersFilterLib } from '@/widgets/offer-filters';

  import { RangeFilter } from '@/shared/ui';

  import TransferAmountFilter from './TransferAmountFilter.vue';
  import TransferWithoutNightFilter from './TransferWithoutNightFilter.vue';

  const props = defineProps<{
    offers: flightEntity.types.MappedOffer[];
    limits: number[];
    state: FilterState;
  }>();

  const emit = defineEmits<{
    onTransferFilterChange: [flightFilterState: Partial<FlightFilterState>];
    onNightTransferFilterChange: [isWithoutNightTransfer: boolean];
  }>();
  const { t } = useI18n();

  const flights = props.offers.flatMap(offer => offer.flights);
  // @ts-expect-error types are similar but not the same
  const availableNumberOfTransfers = new Set(getNumberOfTransfers(flights));
  const maxTransfers = computed(() => props.state.flights[0].transfers[0]);

  function changeMaxTransfers(transfers: number) {
    const newValue = maxTransfers.value === transfers ? null : transfers;
    emit('onTransferFilterChange', {
      transfers: !isNil(newValue) ? [newValue] : [],
    });
  }

  function changeTransferDuration(transferDurationRange: number[]) {
    emit('onTransferFilterChange', {
      transfersDuration: transferDurationRange,
    });
  }
</script>
